"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const fetch_type_enum_1 = require("@Components/WorkItemV2/fetch-type-enum");
const mobx_react_1 = require("mobx-react");
const ViewWork_1 = __importDefault(require("@Components/ViewWork"));
const react_helmet_1 = __importDefault(require("react-helmet"));
require("./index.scss");
const CatalogWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/CatalogWorkHeader"));
const RegHistoryWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/RegHistoryWorkHeader"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Button_1 = require("@Components/Buttons/Button");
const work_registration_forms_1 = require("@Const/work-registration-forms");
const react_router_dom_1 = require("react-router-dom");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const ViewWorkInternalScene = (0, mobx_react_1.observer)((props) => {
    var _a, _b;
    const { workStore, rightsholderStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarOpen, setSidebarOpen] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const params = (0, react_router_dom_1.useParams)();
    const openSidebar = (work) => {
        setSidebarOpen(true);
        workStore.setWorkDraftToLocal(work);
    };
    const closeSidebar = () => {
        setSidebarOpen(false);
        workStore.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
    };
    const claimOnClick = () => {
        workStore.setRedirectingToClaimingTool(true);
        navigate(navigation_1.default.rightholder.matchClaim.claim(rightsholderStore.currentRightsholderId), {
            state: { propertyId: Number(params.workId) },
        });
    };
    (0, react_1.useEffect)(() => {
        preloaderStore.openTransparentPreloader(true);
        (0, analytics_utils_1.analyticsSendPage)('view_work_internal');
        const fetchType = props.fetchType ? props.fetchType : fetch_type_enum_1.FetchType.HFA;
        const workId = params.workId;
        if (!workId || isNaN(Number(workId))) {
            preloaderStore.openTransparentPreloader(false);
            throw new Error('Unable to parse work ID ' + workId);
        }
        workStore.getWorkById(Number(workId), fetchType).then(() => {
            var _a;
            // If it's not a reg history, load the shares
            if (!((_a = workStore.workById) === null || _a === void 0 ? void 0 : _a.submissionId)) {
                rightsholderStore.loadClaimedShares([Number(workId)]).then();
            }
        });
        preloaderStore.openTransparentPreloader(false);
        return () => {
            workStore.destroyViewWork();
            rightsholderStore.resetClaimedShares();
        };
    }, []);
    const work = workStore.workById;
    const myShares = (_b = (_a = rightsholderStore.rightsholderClaimedShares) === null || _a === void 0 ? void 0 : _a.workClaimedShares.find(() => true)) === null || _b === void 0 ? void 0 : _b.rightsholderClaimedShare;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'View Work' }),
        react_1.default.createElement("div", { className: "view-work-scene" }, work && (react_1.default.createElement(react_1.default.Fragment, null,
            work.submissionId ? (react_1.default.createElement(RegHistoryWorkHeader_1.default, { work: work })) : (react_1.default.createElement(CatalogWorkHeader_1.default, { work: work, editOnClick: () => work && openSidebar(work), claimOnClick: () => claimOnClick() })),
            react_1.default.createElement(ViewWork_1.default, { viewWork: work, myShares: myShares, showMatchedRecordings: !work.submissionId, workType: work.submissionId ? 'history' : 'work' }),
            react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarOpen, onClose: closeSidebar },
                react_1.default.createElement("div", { className: "warning-edit-work-popup" },
                    react_1.default.createElement("h3", null, "Confirmation"),
                    react_1.default.createElement("p", null,
                        "Please confirm that you wish to begin editing \"",
                        work.title,
                        "\"."),
                    react_1.default.createElement("div", { className: "links-block" },
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: closeSidebar }, "Cancel"),
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', typeLink: true, linkTo: navigation_1.default.rightholder.catalog.workEdit.root(rightsholderStore.currentRightsholderId, 'work', work.id) }, "Edit")))))))));
});
exports.default = ViewWorkInternalScene;
